export enum ImageTypeLabel {
  raw_images = 'Imagens brutas - Sem geo tags  ',
  raw_images_geotag = 'Imagens brutas - Com geo tags  ',
  mosaic = 'Ortomosaico',
}

export type ImageType = keyof typeof ImageTypeLabel
